module.exports = __webpack_public_path__ + "static/media/reset-pass.98105658.svg";